<div class="product-detail-container">
  <app-tvshop-header [titleKey]="'eos-tv-shop-ii.title.main-tv-shop-header'"></app-tvshop-header>
  <div class="container">
    <div *ngIf="packs?.length > 1"
         class="deep-linking-title"
         [translate]="'eos-tv-shop-ii.main-deep-linking-title-type-' + (titleType ? titleType : 'linear').toLocaleLowerCase()"></div>
    <div class="deep-linking-options-container">
      <div class="option" *ngFor="let pack of packs; let i = index">
        <app-deep-linking-option
          [x]="i*2"
          [y]="0"
          [pack]="pack"
          [omapiId]="pack?.omapiId"></app-deep-linking-option>
      </div>
    </div>
  </div>
</div>
